module.exports = __webpack_public_path__ + "static/media/ptsans-bold.ba61c58d.woff";